<template>
  <el-dialog
    class="evaluate-dialog"
    title="客服评价"
    :visible.sync="visibleEvaluate"
    :modal-append-to-body="false"
    :show-close="false"
  >
    <span class="icon-close" @click="close">
      <i class="el-icon-close"></i>
    </span>
    <evaluateResultModel v-if="cusEvaluateState" />
    <evaluate-model v-else />
  </el-dialog>
</template>

<script>
import evaluateModel from "./evaluate-model";
import evaluateResultModel from "./evaluate-result-model";

export default {
  name: "evaluate-page",
  components: { evaluateModel, evaluateResultModel },
  computed: {
    ...mapState({
      visibleEvaluate: state => state.visibleEvaluate, //弹窗显示flag
      evaluateConfig: state => state.evaluateConfig, //评论配置
      evaluateResult: state => state.evaluateResult //评论结果
    }),
    cusEvaluateState() {
      //用户评价状态 已评价/未评价
      return this.evaluateResult.cusEvaluateState;
    }
  },
  watch: {
    visibleEvaluate: {
      handler() {
        const { evaluateStarName } = this.evaluateConfig;
        this.$store.dispatch("getEvaluateResult");
        !evaluateStarName && this.$store.dispatch("getEvaluateConfig"); //优化接口请求
      }
    }
  },
  methods: {
    close() {
      this.$store.commit("setState", {
        invitationEvaluateFlag: false,
        visibleEvaluate: false
      });
    }
  }
};
</script>

<style lang="less" scoped>
.pc {
  .evaluate-dialog {
    position: absolute;

    /deep/ .el-dialog {
      width: 450px;
      height: auto;
      padding-bottom: 30px;
      text-align: center;

      .icon-close {
        cursor: pointer;
      }

      .el-dialog__header {
        position: relative;
        height: 40px;
        padding: 0;
        text-align: center;
        border-bottom: 1px solid #eaeaea;

        .el-dialog__title {
          font-size: 14px;
          line-height: 40px;
          color: #1e1e1e;
        }

        .el-dialog__headerbtn {
          right: 12px;
          top: 50%;
          transform: translateY(-50%);

          .el-dialog__close {
            color: #000;
            font-size: 18px;
          }
        }
      }

      .el-dialog__body {
        padding: 0 20px;
      }

      .el-dialog__footer {
        position: absolute;
        bottom: 15px;
        left: 50%;
        transform: translateX(-50%);
        padding: 0;
      }
      .icon-close {
        position: absolute;
        top: 4px;
        right: 6px;
        padding: 5px 8px;
        i {
          font-size: 20px;
        }
      }
    }
  }
}

.mobile {
  .evaluate-dialog {
    position: fixed;
    /deep/ .el-dialog {
      width: 340px;
      height: auto;
      text-align: center;

      .el-dialog__header {
        position: relative;
        height: 40px;
        padding: 0;
        text-align: center;
        border-bottom: 1px solid #eaeaea;

        .el-dialog__title {
          font-weight: 500;
          font-size: 16px;
          color: #1e1e1e;
          line-height: 40px;
        }

        .el-dialog__headerbtn {
          right: 12px;
          top: 50%;
          transform: translateY(-50%);

          .el-dialog__close {
            color: #000;
            font-size: 18px;
          }
        }
      }

      .el-dialog__body {
        padding: 0 6px 16px 6px;
      }

      .el-dialog__footer {
        padding: 0;

        .dialog-footer {
          width: 100%;
          display: flex;
          justify-content: center;
        }
      }
      .icon-close {
        position: absolute;
        top: 4px;
        right: 6px;
        padding: 5px 8px;
        i {
          font-size: 20px;
        }
      }
    }
  }
}
</style>
